import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchContainer'
import DrugCatlogTable from './DrugCatlogTable'
import Drawer from 'components/Drawer'
import { Card, CardBody } from 'reactstrap'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ErrorBoundary from 'components/ErrorBoundary'
import useContextService from 'hooks/useContextService'
import useAxios from 'hooks/useAxios'
import { cloneDeep } from 'lodash'
import DrugCatalogPriceHistory from './DrugCatlogPriceHistory';

let filters = [];
let hospitalID = "";
let acctType = "";

const DrugCatlogPage = (props) => {
  const { orgId, reset, tabKey } = props;
  const [columnFilters, setColumnFilters] = useState([]);
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [data, setData] = useState([]);
  const [totalitem, setTotalItem] = useState(0);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resetFilterFlag, SetResetFilterFlag] = useState(false);
  const API = useAxios();
  const {
    states: { drugCatalog },
    setStates,
  } = useContextService();
  const { search, coveredEntity, searchTerms, claimStatusID } = drugCatalog;
  const [dataPriceHistoryData, setDataPriceHistoryData] = useState([]);

  useEffect(() => {
    handleReset();
  }, [orgId, reset]);

  const handleReset = () => {
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
  };

  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
    // onReset();
  }, []);

  const refetch = () => {
    setColumnFilters([]);
    drugCatalog.search.currentPage = 1;
    fetchDrugCatalogAll(search);
  };

  const fetchPriceHistory = async (rowData, accountType) => {
    let accountCode = '';
    if (accountType === 'WAC') {
      accountCode = rowData.accountCodeWAC;
    } else if (accountType === '340B') {
      accountCode = rowData.accountCode340B;
    } else if (accountType === 'GPO') {
      accountCode = rowData.accountCodeGPO;
    }
    setLoading(true);
    try {
      const { data } = await API.get(`SBTenant/${orgId.tenantID}/DrugCatalog/PriceHistory/${hospitalID}/${accountCode}/${rowData.drugID}`,
        {
          hasDefaultURL: true,
          hideLoader: true
        }
      )

      if (data) {
        setDataPriceHistoryData(data);
      } else {
        setDataPriceHistoryData([]);
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
    }
  };

  const handleSearch = async (filter) => {
    const {
      accumulationIDs,
      hospitalDD
    } = filter;

    hospitalID = parseInt(hospitalDD);
    const tableRes = document.querySelector('.table-responsive');
    tableRes.scrollLeft = 0;
    search.filters = filters;
    search.AccumulatorID = accumulationIDs[0];
    search.Hospital = parseInt(hospitalDD);
    if (tabKey === "drugcatlog")
      await fetchDrugCatalogAll(search);
  };

  const fetchDrugCatalogAll = async (filters) => {
    if (!(orgId?.tenantID)) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    try {
      // if (filters.AccumulatorIDs.length > 0) {
      const { data } = await API.post(`SBTenant/${orgId.tenantID}/DrugCatalog/All`, filters,
        { hasDefaultURL: true, }
      )
      if (data) {
        setData(data.items);
        // setcollapseSider(true);
        setCollIcon(faAngleDown);

        setTotalItem(data.totalRecords);
      } else {
        setData([]);
        setTotalItem(0);
      }

    } catch (error) { }
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    }
    else {
      setCollIcon(faAngleUp);
    }
  }
  const handlePageChange = (filter, haveColFilter) => {
    updateDrugCatalogSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      drugCatalog.search = { ...drugCatalog.search };
      fetchDrugCatalogAll(filterObj);

    } else {
      fetchDrugCatalogAll(filter);
      drugCatalog.search = { ...drugCatalog.search, ...filter };
    }
    setStates('drugCatalog', drugCatalog);
  };

  const updateDrugCatalogSearch = (filter) => {
    drugCatalog.search.currentPage = filter.currentPage;
    drugCatalog.search.pageSize = filter.pageSize;
    drugCatalog.search.orderBy = filter.orderBy;
    drugCatalog.search.order = filter.order;
  }


  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    drugCatalog.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchDrugCatalogAll(filterObj);
  };

  const togglePriceHistory = (rowdata, accountType) => {
    setModal(!modal);
    setDataPriceHistoryData([]);
    if (!accountType) return;
    acctType = accountType;
    fetchPriceHistory(rowdata, accountType);
  };

  return (
    <div>
      <div className="border-0">
        <Card className="border-0 shadow-top  drug_tabs">
          <CardBody hidden={collapseSider}  >
            <div className=''>
              <ErrorBoundary>
                <SearchContainer
                  orgId={orgId}
                  onSearch={handleSearch}
                  onReset={handleReset}
                  reset={reset}
                />
              </ErrorBoundary>
            </div>
          </CardBody>
        </Card>
        <Card className="border-0 shadow-top mt-2">
          <CardBody>
            <div className=''>
              <ErrorBoundary>
                <DrugCatlogTable
                  togglePriceHistory={togglePriceHistory}
                  data={data}
                  filters={search}
                  totalitem={totalitem}
                  resetFilterFlag={resetFilterFlag}
                  SetResetFilterFlag={SetResetFilterFlag}
                  orgId={orgId}
                  onPageChange={handlePageChange}
                  refetch={refetch}
                  onSearchColumnFilters={handleSearchColumnFilters}
                  collapseSider={collapseSider}
                  toggleSider={toggleSider}
                  tabKey={tabKey}
                />
              </ErrorBoundary>
            </div>
          </CardBody>
        </Card>
      </div>
      <Drawer
        direction="end"
        title="Price History"
        isOpen={modal}
        toggle={togglePriceHistory}
        size="lg"
      >
        <DrugCatalogPriceHistory data={dataPriceHistoryData} loading={loading} acctType={acctType} />
      </Drawer>
    </div>
  );
}

export default DrugCatlogPage